// Copyright © 2021 Move Closer

/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export const CaptchaMiddlewareType = Symbol.for('CaptchaMiddleware')
